import React from 'react';

export function BoldLTRColumnFormatter(cellContent) {
  return (
    <span dir='ltr' className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
      {cellContent}
    </span>
  );
}
